<template>
	<div class="container ar">
		<div class="title">
			<breadcrumbs
				:links="[
					{ name: $t('links.home'), link: { name: 'home' } },
					{ name: $t('links.contact'), link: {}, active: 'true' },
				]"></breadcrumbs>
			<div class="title-name">{{ $t('links.contact') }}</div>
		</div>
		<div class="main row">
			<div class="left col-lg-7 col-md-7 col-12">
				<form @submit.prevent="submit" ref="form" novalidate>
					<div class="f-title">{{ $t('contacts.title') }}</div>

					<!-- email -->
					<input
						v-model="email"
						type="email"
						:placeholder="$t('contacts.email')"
						class="email"
						:class="{ 'not-valid': needToValidation }"
						required />

					<!-- type -->
					<select
						v-model="type"
						class="type"
						:placeholder="$t('contacts.type')"
						:class="{ 'not-valid': needToValidation }"
						required>
						<option value disabled selected hidden>{{ $t('contacts.type') }}</option>
						<option value="Green">Green</option>
						<option value="Red">Red</option>
						<option value="Blue">Blue</option>
						<option value="Black">Black</option>
						<option value="Red">Yellow</option>
					</select>

					<!-- massage -->
					<label for="massage">{{ $t('contacts.message') }}</label>
					<input
						type="text"
						v-model="message"
						id="massage"
						class="massage"
						:class="{ 'not-valid': needToValidation }"
						required />

					<div class="d-flex align-items-center">
						<button class="btn-send" :class="{ disabled: loading }" type="submit">
							{{ $t('contacts.send') }}
						</button>

						<div v-if="loading" class="spinner-grow spinner-grow-sm text-dark me-2" role="status">
							<span class="visually-hidden">Loading...</span>
						</div>
					</div>

					<div v-if="errorMessage" class="text-danger">
						{{ errorMessage }}
					</div>
				</form>
			</div>
			<div class="right col-lg-5 col-md-5 col-12">
				<div class="contact">
					<div class="phone">
						<i class="fas fa-phone ms-3"></i>
						<a href="tel:0212663132" dir="auto">021-266 3132</a>
					</div>
					<div class="fax">
						<i class="fas fa-fax ms-3"></i>
						<a href="fax:0212643832" dir="auto">021-264 3832</a>
					</div>
					<div class="mail">
						<i class="fas fa-envelope ms-3"></i>
						<a href="mailto:alepuniv.rja@gmail.com" dir="auto">alepuniv.rja@gmail.com</a>
					</div>
				</div>
				<div class="social">
					<a
						href="https://www.facebook.com/%D9%85%D8%AC%D9%84%D8%A9-%D8%A8%D8%AD%D9%88%D8%AB-%D8%AC%D8%A7%D9%85%D8%B9%D8%A9-%D8%AD%D9%84%D8%A8-207291042768690/"
						target="_blank"
						><i class="fab fa-facebook-f"></i
					></a>
					<i class="fab fa-linkedin-in"></i>
					<i class="fab fa-instagram"></i>
					<i class="fab fa-twitter"></i>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs';
export default {
	components: {
		Breadcrumbs,
	},

	data() {
		return {
			needToValidation: false,
			loading: false,
			errorMessage: null,

			email: null,
			type: '',
			message: null,
		};
	},

	methods: {
		submit() {
			this.errorMessage = null;
			if (this.$refs.form.checkValidity()) {
				this.loading = true;
				this.$store
					.dispatch('contact/sendMessage', {
						email: this.email,
						type: this.type,
						body: this.message,
					})
					.catch((e) => {
						this.errorMessage = e;
					})
					.finally(() => {
						this.loading = false;
					});
			} else {
				this.needToValidation = true;
			}
		},
	},
};
</script>

<style scoped>
.container {
	margin-top: 50px;
	padding-bottom: 50px;
}
.container > div {
	margin: 0 50px;
}

.title-name {
	color: var(--green-color);
	font-family: changeBold;
	text-transform: uppercase;
	font-size: 52px;
	line-height: 4rem;
	margin-bottom: 40px;
	text-align: center;
}
.main {
	border-top: 2px solid var(--borders-color);
	padding-top: 30px;
}
.left {
	padding: 20px;
}
form {
	width: 100%;
	box-shadow: 0px 0px 20px #ddd;
	padding: 20px 80px;
	border-radius: 10px;
}
form > * {
	width: 100%;
	margin: 15px 0;
	font-size: 15px;
	color: var(--text-color);
}
.f-title {
	font-size: 18px;
	font-family: changeBold;
}
.email,
.massage,
.type {
	border: none;
	border-bottom: 2px solid var(--borders-color);
	padding: 10px 0;
}
.email:focus,
.massage:focus,
.type:focus {
	outline: none;
	border-bottom: 2px solid var(--green-color);
}

.type {
	background: white;
}
.type option {
	background: white;
	padding: 10px 0;
}
label {
	margin-bottom: 0px;
}
.btn-send {
	background: linear-gradient(to right, var(--yellow-color-2), var(--green-color));
	width: max-content;
	padding: 6px 40px;
	border-radius: 30px;
	color: white;
	border: none;
	font-family: changeBold;
}
.right {
	padding: 50px;
	padding-right: 20px;
}
.contact {
	border-bottom: 2px solid var(--borders-color);
}
.contact div {
	padding: 25px 0;
	font-size: 15px;
	color: var(--text-color);
}
.contact .mail {
	padding-bottom: 50px !important;
}
.contact img {
	height: 18px;
	margin: 0 10px;
}
.social {
	padding: 50px 0;
}
.social svg {
	margin-right: 30px;
	height: 20px;
	width: 20px;
}
@media only screen and (max-width: 992px) {
	.container > div {
		margin: 0 10px;
	}
	.title {
		font-size: 23px;
	}
	.title-name {
		font-size: 43px;
	}
	form {
		padding: 5px 30px;
	}
	form * {
		font-size: 14px;
	}
	.btn-send {
		padding: 7px 45px;
	}
	.email,
	.massage,
	.type {
		margin: 20px 0;
	}
	.right {
		padding: 10px;
	}
	.contact div {
		font-size: 16px;
	}
	.contact img {
		height: 20px;
	}
	.social svg {
		width: 22px;
		height: 22px;
	}
}
@media only screen and (min-width: 1400px) {
	.main {
		max-width: 1400px;
		margin: 0 auto !important;
	}
}
</style>
